import styled from 'styled-components';
import { Flex } from 'rebass/styled-components';

export const TextBlock = styled(Flex)`
  min-height: 20em;
`;
